/*
* @Author: msmiller
* @Date:   2020-07-04 11:51:59
* @Last Modified by:   msmiller
* @Last Modified time: 2021-08-21 13:58:27
*
* Copyright (c) Sharp Stone Codewerks / Mark S. Miller
*/

import Rails from '@rails/ujs'
import { debounce } from 'lodash-es'
import ApplicationController from './application_controller'

let lastMessageId
const reload = controller => {
  controller.stimulate('TimelineReflex#reload')
}
const debouncedReload = debounce(reload, 100)

export default class extends ApplicationController {
  static targets = ['list', 'input']

  connect () {
    super.connect()
    //this.scroll(100)
    console.log("TimelineController connected")
  }

  post (event) {
    console.log( "... post" );
    Rails.stopEverything(event)
    lastMessageId = Math.random()
    this.stimulate(
      'TimelineReflex#post',
      this.element.dataset.color,
      this.inputTarget.value,
      lastMessageId
    )
  }

  delete_post (event) {
    // TODO: Put in the proper channel_id for each button ... or just skip this requirement?
    var channelId = parseInt( this.data.get('channel') || 0 );
    var postlId = parseInt( $(event.currentTarget).data('postid') );

    $.post( {
      url: "/channels/" + channelId + "/destroy_post/" + postlId,
      headers: { 'X-CSRF-Token': AUTH_TOKEN }
    });
  }

  load_post (event) {
    // TODO: Put in the proper channel_id for each button ... or just skip this requirement?
    var channelId = parseInt( this.data.get('channel') || 0 );
    var postlId = parseInt( $(event.currentTarget).data('postid') );

    // $.post( {
    //   url: "/channels/" + channelId + "/destroy_post/" + postlId,
    //   headers: { 'X-CSRF-Token': AUTH_TOKEN }
    // });
  }

  afterPost () {
    console.log( "... afterPost" );
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.scroll(1)
  }

  scroll (delay = 10) {
    console.log( "... scroll" );
    const lists = document.querySelectorAll('[data-target="chat.list"]')
    setTimeout(() => {
      lists.forEach(e => (e.scrollTop = e.scrollHeight))
    }, delay)
  }

//  reload (event) {
//    console.log( "... reload" );
//    const { messageId } = event.detail
//    if (messageId === lastMessageId) return
//    debouncedReload(this)
//  }
//
//  load_timeline (event) {
//    console.log( "TimelineController#load_timeline"  );
//    console.log( event );
//    this.stimulate(
//      'TimelineReflex#reload'
//    )
//    console.log( 'stimulate sent!' );
//
//  }

/*
 * TODO: Map in escape key to dismiss modal
 * SEE: https://discourse.stimulusjs.org/t/add-and-remove-eventlisteners/710/2
 */

  show_modal() {
//    $('#postmodal').addClass('is-active');
    $('#postmodal').removeClass('hidden');
  }


  show_more(event) {
    var postId = parseInt( $(event.currentTarget).data('postid') );
    var channelId = parseInt( $(event.currentTarget).data('channelid') );
    // console.log(postId);
    // console.log(channelId);
    $.post( {
      url: "/channels/" + channelId + "/show_more/" + postId,
      headers: { 'X-CSRF-Token': AUTH_TOKEN }
    });
  }

  hide_modal() {
//    $('#postmodal').removeClass('is-active');
    $('#postmodal').addClass('hidden');
  }

  show_media() {

    // Move the below into a separate MediaModalController to handle the reflex better
    $('#mediamodal #mediacontent').html(
      "<div id='media_spinner' class='px-10 py-10'><center>" +
      "<svg class='animate-spin -ml-1 mr-3 h-10 w-10 text-red-600' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>" +
      "<circle class='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' stroke-width='4'></circle>" +
      "<path class='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>" +
      "</svg>" +
    "</center></div>");
    $('#mediamodal').removeClass('hidden');
  }


  hide_media() {
    $('#mediamodal').addClass('hidden');
  }
}
